import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PublicAvailability,
  PublicSalesAvailabilityBadgeCssClassPipe,
  PublicSalesAvailabilityLabelPipe,
} from '@web/shared/module/shop';

@Component({
  selector: 'app-public-box-status-label',
  imports: [
    CommonModule,
    PublicSalesAvailabilityBadgeCssClassPipe,
    PublicSalesAvailabilityLabelPipe,
  ],
  templateUrl: './public-box-status-badge.component.html',
  styleUrl: './public-box-status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxStatusBadgeComponent {
  /* prettier-ignore */
  public readonly availability = input.required<PublicAvailability>();
}
